import BaseException from './base_exception'

class InvalidDateFormat extends BaseException {
  constructor(value) {
    super('hs.errors.invalid_date_format', { value })
  }
}

export default InvalidDateFormat
